import { render, staticRenderFns } from "./AddItemTypeAdditonalItemModal.vue?vue&type=template&id=6dc2f2a5"
import script from "./AddItemTypeAdditonalItemModal.vue?vue&type=script&lang=js"
export * from "./AddItemTypeAdditonalItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports